import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

// Libs
import MicroModal from 'micromodal';
import { useTranslation } from 'next-i18next';
// Utils
import { cn } from 'utils';
// Hooks
import useResponsiveQueries from '../../../src/hooks/useResponsiveQueries';

// Components
import Button from '../../atoms/Button/Button';
import { Picto } from '../../atoms/Picto/Picto';

import styles from './Modal.module.css';

function Modal({
  id, title, children, maxWidth, actionButton, hideCancelButton, theme, fullScreen,
}) {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveQueries();

  return id && document?.body ? (
    createPortal(
      <div id={id} className={cn(['modal', styles[theme]])}>
        <div
          role="presentation"
          onClick={() => MicroModal.close(id)}
          className="modal_layer"
        />
        <div className={cn(['modal_window', fullScreen ? styles.fullScreen : ''])} style={isMobile ? {} : { maxWidth }}>
          <div className="modal_body">
            <div className="d-flex margin-bottom-24 modal_header">
              {title && (
              <h3 className="h3-desktop-bold font-color-blue h3-mobile-bold">{title}</h3>
              )}
              <div className={cn(['d-flex center margin-left-auto', !fullScreen && 'padding-left-24'])}>
                <button
                  type="button"
                  className={cn(['d-flex center font-color-blue cursor-pointer', styles.close])}
                  onClick={() => MicroModal.close(id)}
                  aria-label={t('common.close')}
                >
                  <Picto icon="cross" />
                </button>
              </div>
            </div>

            <div className="p1-desktop-default p1-mobile-default modal_container">
              {children}
            </div>
          </div>

          {actionButton ? (
            <div className={cn([styles.cta_bottom, 'd-flex a-stretch j-end mobile-d-col'])}>
              {!hideCancelButton ? (
                <Button
                  className={styles.cta}
                  color="secondary"
                  onClick={() => MicroModal.close(id)}
                >
                  {t('common.cancel')}
                </Button>
              ) : null}

              {actionButton}
            </div>
          ) : null}

        </div>
      </div>,
      document.body,
    )
  ) : null;
}

Modal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  maxWidth: PropTypes.number,
  actionButton: PropTypes.node,
  hideCancelButton: PropTypes.bool,
  fullScreen: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark', 'neutral', 'virtualVisit', '']),
};

Modal.defaultProps = {
  title: null,
  children: null,
  maxWidth: null,
  actionButton: null,
  hideCancelButton: false,
  fullScreen: false,
  theme: 'light',
};

export default Modal;
